<div class="relative">
  <textarea
    class="w-full mb-4"
    [ngClass]="{ 'ng-invalid': invalid }"
    style="resize: none"
    [rows]="rows"
    pInputTextarea
    [(ngModel)]="text"
    (ngModelChange)="textChange.emit($event)"
  >
  </textarea>

  <!-- Floating expand Button -->
  <button
    class="floating-btn"
    pButton
    pRipple
    type="button"
    icon="fa fa-expand"
    pTooltip="Agrandir la zone de texte"
    i18n-pTooltip="@@extensible_textarea_maximize"
    label=""
    (click)="showDialog()"
  ></button>
</div>

<!-- Dialog for expanded editing -->
<p-dialog
  #dialog
  [(visible)]="displayDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="false"
>
  <ng-template pTemplate="headless">
    <div class="relative">
      <textarea
        pInputTextarea
        [(ngModel)]="text"
        (ngModelChange)="textChange.emit($event)"
        cols="80"
        rows="40"
      ></textarea>

      <!-- Floating minimize Button -->
      <button
        class="floating-btn"
        pButton
        pRipple
        type="button"
        icon="fa fa-compress"
        pTooltip="Minimiser la zone de texte"
        i18n-pTooltip="@@extensible_textarea_minimise"
        label=""
        (click)="dialog.close($event)"
      ></button>
    </div>
  </ng-template>
</p-dialog>
